export default "__VITE_ASSET___OlzMJMl__"